import { render } from "./SearchBar.vue?vue&type=template&id=2d66a3ad&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=2d66a3ad&lang=scss&scoped=true"
import "./SearchBar.vue?vue&type=style&index=1&id=2d66a3ad&lang=scss&global=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d66a3ad"]])

export default __exports__